import * as PayrollActions from './payroll.actions';
import * as PayrollUIActions from './payroll.ui.actions';
import * as PayrollExtraActions from './payroll.extra.actions';
import * as PayrollRuleActions from './payroll.rule.actions';

export {
  PayrollActions,
  PayrollUIActions,
  PayrollExtraActions,
  PayrollRuleActions,
};
